/**
 * Get fileName given a filepath
 * @param {string} filePath the file path
 * @param {bool} withExtension whether the filename should include the file extension
 */
export function getFileName(filePath, withExtension) {
  if (filePath) {
    const fragments = filePath.split('/')
    if (fragments.length > 0) {
      const fileNameWithExtension = fragments[fragments.length - 1]

      return withExtension === true
        ? fileNameWithExtension
        : fileNameWithExtension.substring(0, fileNameWithExtension.indexOf('.'))
    }
  }
  return ''
}
